<template>
  <div class="millikan-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>q = mg / E | q = ne$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：油滴在电场中运动 -->
      <div class="canvas-mixed simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 极板 -->
            <rect x="100" y="40" width="200" height="4" fill="#888" />
            <rect x="100" y="176" width="200" height="4" fill="#888" />
            
            <!-- 油滴 -->
            <circle v-for="p in droplets" :key="p.id" :cx="p.x" :cy="p.y" :r="p.r" fill="#ffd700" opacity="0.8" />

            <!-- 电场线 -->
            <g v-if="voltage > 0">
               <line v-for="i in 5" :key="'ef'+i" 
                 :x1="120+i*30" y1="45" :x2="120+i*30" y2="175" 
                 stroke="rgba(0,210,255,0.2)" stroke-dasharray="4,2" marker-end="url(#arr-e)" />
            </g>
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>电场强度 E</label>
               <span class="val">{{ electricField.toFixed(1) }} V/m</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col-full">
                  <label>调节电压 (平衡油滴): {{ voltage }} V</label>
                  <el-slider v-model="voltage" :min="0" :max="500" size="mini"></el-slider>
               </div>
            </div>
         </div>

         <div class="discovery-note" v-latex>
            <p><strong>实验原理：</strong>通过调节电压使油滴<strong>悬浮</strong>（$qE = mg$），密立根发现所有油滴带电量都是某一最小单位的整数倍，从而测定了<strong>元电荷 e</strong>。这是量子化特性的重要物理证据。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MillikanViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      voltage: 100,
      droplets: [],
      running: true
    }
  },
  computed: {
    electricField() { return this.voltage / 0.1; }
  },
  methods: {
    initDroplets() {
       for(let i=0; i<10; i++) {
          this.droplets.push({
             id: i,
             x: 150 + Math.random()*100,
             y: 60 + Math.random()*100,
             r: 2 + Math.random()*2,
             v: 0,
             q: Math.ceil(Math.random()*5) * 1.6 // elementary units
          });
       }
    },
    animate() {
       if (!this.running) return;
       
       this.droplets.forEach(p => {
          // Force Balance: Fnet = qE - mg
          // For simplicity: q is in charge units, E is normalized
          const gravity = p.r * 2;
          const eForce = (p.q * this.voltage) / 20;
          const accel = (gravity - eForce) * 0.1;
          
          p.v = p.v * 0.8 + accel;
          p.y += p.v;
          
          // Boundaries
          if (p.y < 45) { p.y = 45; p.v = 0; }
          if (p.y > 170) { p.y = 170; p.v = 0; }
       });

       requestAnimationFrame(this.animate);
    }
  },
  mounted() {
    this.initDroplets();
    this.animate();
  },
  beforeDestroy() { this.running = false; }
}
</script>

<style scoped lang="scss">
.millikan-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffd700; background: rgba(255,215,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-mixed { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; .val { font-family: monospace; color: #00d2ff; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { .col-full { label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } } }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
